import { render, staticRenderFns } from "./orderShare.vue?vue&type=template&id=415f8242&scoped=true&"
import script from "./orderShare.vue?vue&type=script&lang=js&"
export * from "./orderShare.vue?vue&type=script&lang=js&"
import style0 from "./orderShare.vue?vue&type=style&index=0&id=415f8242&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415f8242",
  null
  
)

export default component.exports